<div class="app-logo" [ngClass]="size">
  <div class="app-logo-icon" [ngClass]="{'transparent-icon': transparentIcon}"></div>
  <div class="app-logo-name" [ngStyle]="{ 'color': color }">{{ appName }}
    <div class="dev-badge-wrapper" *ngIf="!env.production">
      <a href="javascript:void(0)" (click)="devInfo()" class="dev-badge">DEV <span *ngIf="size !== 'medium'">version</span></a>
    </div>
  </div>
</div>
